<template>
    <a href="#" class="bike-details-comparison-button ec-link" :class="{'active': active}" title="Comparer ce vélo"
       @click="toggleComparison()">
        <span class="bike-details-comparison-button--text">
            <i class="ec-icon ec-icon-compare"></i>
            Comparer ce produit
        </span>
        <div class="bike-details-comparison-button--overlay"> </div>
    </a>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    .bike-details-comparison-button {
        &.ec-link, &.ec-link:active, &.ec-link:focus {
            color: $text-color !important;
            position: relative;
            display: block;

            .bike-details-comparison-button--text {
                position: relative;
                z-index: 1;
            }

            .bike-details-comparison-button--overlay {
                display: block;
                background: transparent;
                z-index: 0;
                top: -$grid-gutter-width/3;
                left: -$grid-gutter-width/4;
                position: absolute;
                right: -$grid-gutter-width/3;
                bottom: -$grid-gutter-width/4;
                @include border-radius(5px);
                @include transition(background 0.3s ease)
            }

            &.active, &:hover {
                color: $ec-color-white !important;

                .bike-details-comparison-button--overlay {
                    background: $ec-primary-color;
                }
            }

            &.active:hover {
                .bike-details-comparison-button--overlay {
                    background: $ec-primary-color-dark;
                }
            }
        }
    }
</style>

<script type="text/babel">
    let compareButton = require('./mixins/CompareButton.js');

    export default {
        mixins: [compareButton]
    }
</script>